import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConstructAPI } from '../API/constructAPI';
import { RestApiService } from '../API/restapi';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private router = inject(Router);
  private constructApi = inject(ConstructAPI);
  private restApi = inject(RestApiService);

  // private signUpURL = "http://206.189.87.13:10080/api/v1/signup";
  // private signInURL = "http://206.189.87.13:10080/api/v1/signin";

  userLoggedIn = new BehaviorSubject<any>([]);

  constructor() {
    this.userLoggedIn.next(!!sessionStorage.getItem('username'));
  }


  registerUser(userInfo) {
    // return this.http.post<any>(this.signUpURL, userInfo,{withCredentials:true})
    // var xhr = new XMLHttpRequest();

    // xhr.open("POST", this.constructApi.getSignUp(), true);
    // xhr.setRequestHeader("Content-type", "application/json");
    // xhr.withCredentials = true;

    // var data = JSON.stringify(userInfo);
    // xhr.send(data);

    const data = userInfo;
    const xhr = this.restApi.postRequest(this.constructApi.getSignUp(), data);
    return xhr
  }


  login(userInfo) {
    // var xhr = new XMLHttpRequest();

    // xhr.open("POST", this.constructApi.getSignIn(), true);
    // xhr.setRequestHeader("Content-type", "application/json");
    // xhr.withCredentials = true;

    // var data = JSON.stringify(userInfo);
    // xhr.send(data);
    const data = userInfo;
    const xhr = this.restApi.postRequest(this.constructApi.getSignIn(), data);
    return xhr
  }

  refreshToken(){
    const xhr = this.restApi.getRequest(this.constructApi.getTokenRefresh());
    return xhr
  }

  loggedIn() {
    // return !!this.cookieService.get('token');
    return !!sessionStorage.getItem('username');
  }


  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }

  logout() {
    sessionStorage.clear();
    // this.cookieService.delete('token');
    this.userLoggedIn.next(false);
    this.router.navigate(['/loginPage']);

  }
}
